import { useCallback } from 'react';
import { useToastProgress } from 'App/components/ToastProgressContext';
import { useToast } from 'commons/hooks';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

export type LocationToastTypes =
  | 'sort'
  | 'setAsMain'
  | 'delete'
  | 'deleteSteps';

interface UseLocationToastResult {
  onError: (type: LocationToastTypes) => void;
  onSuccess: (type?: LocationToastTypes) => void;
  onLoading: (type: LocationToastTypes) => void;
}

function useLocationListToast(): UseLocationToastResult {
  const t = useTranslationShipping();
  const { addToast } = useToast();
  const { addToastProgress, closeToastProgress } = useToastProgress();

  const onError = useCallback(
    (type: LocationToastTypes) => {
      closeToastProgress();
      addToast({
        label: t(`locations.${type}.error`),
        appearance: 'danger',
      });
    },
    [closeToastProgress, addToast, t],
  );

  const onSuccess = useCallback(
    (type?: LocationToastTypes) => {
      closeToastProgress();
      type &&
        addToast({
          label: t(`locations.${type}.success`),
          appearance: 'success',
        });
    },
    [closeToastProgress, addToast, t],
  );

  const onLoading = useCallback(
    (type: LocationToastTypes) => {
      addToastProgress({
        label: t(`locations.${type}.loading`),
      });
    },
    [addToastProgress, t],
  );

  return {
    onError,
    onSuccess,
    onLoading,
  };
}

export default useLocationListToast;
